module.exports = __webpack_public_path__ + "img/youtube.57438f50.svg";